<template>
  <!-- Footer -->
  <div class="horiz ol-t c-p3 bg-p1 h-stretch">
    <div class="m2-x p3-x c-c2"> © 2019-{{getyear()}} Investor's AI, LLC.  All Rights Reserved</div>
    <div class="m3-r m1-y btn-underline c-p3 h-end" @click="$router.push({ name: 'privacy' })"> Privacy Policy </div>
    <div class="m3-l m3-r m1-y btn-underline c-p3 h-end" @click="$router.push({ name: 'clientterms' })">
      Terms of Use </div>
  </div>
</template>

<script>
export default {
  methods: {
    getyear() {
      const dt = new Date();
      return dt.getFullYear();
    },
  }
}
</script>